// extracted by mini-css-extract-plugin
export default {"modalOverlay":"DI-z","modalContent":"EI-z","header":"FI-z","close":"GI-z"};